import React from "react";
import ElgonHeader from "./ElgonHeader";
import ElgonSections from "./ElgonSections";

const Elgon = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <ElgonHeader />
      <ElgonSections />
    </div>
  );
};

export default Elgon;
